<template>
  <a-modal
      title="创建任务"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="visible = false"
      destroy-on-close
      :afterClose="afterClose"
  >
    <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="任务名称" prop="job_name">
        <a-input :size="$globalSize" v-model="form.job_name"/>
      </a-form-model-item>
      <a-form-model-item label="任务类型" prop="job_type">
        <a-select :size="$globalSize"
            v-model="form.job_type"
            :options="taskTypeOptions"
        />
      </a-form-model-item>
      <a-form-model-item label="执行线程" prop="thread">
        <a-input :size="$globalSize" v-model="form.thread"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import utils from "@/utils";
import workflow from "@/interface/pages/workflow/workflow";
const taskTypeOptions= [
  {title: "创建", value: 'create'},
  {title: "过滤", value: 'filter'},
  {title: "生成", value: 'build'},
  {title: "回传", value: 'upload'},
  {title: "检查", value: 'check'},
  {title: "推送", value: 'push'},
  {title: "合并", value: 'merge'},
  {title: "平台", value: 'service'}
]
export default {
  name: "createTaskModal",
  components: {},
  props: {},

  data() {
    return {
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      visible: false,
      confirmLoading: false,
      form: {
        job_name:undefined,
        job_type:undefined,
        thread:undefined
      },
      taskTypeOptions
    };
  },
  mounted() {
    utils.languageChange(this, {labelCol: 9, wrapperCol: 14}, {labelCol: 6, wrapperCol: 16})
  },
  computed: {},
  watch: {},
  methods: {
    showModal() {
      this.visible = true;
    },
    async submit() {
      const {data: res} = await workflow.addJob(this, {data:this.form})
      try {
        if (res.code === '200') {
          this.$message.success('创建成功')
          this.visible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    },
    afterClose() {
      this.$refs.ruleForm.resetFields()
    }
  },
};
</script>

<style scoped lang="less">
::v-deep .ant-modal-body {
  padding-left: 24px;
}
</style>
